import { lang } from "../language/Strings";

export const getLocalizedDeviationTypeFromNumber = (name: number) => {
  switch (name) {
    case 2:
      return lang.urgent;
    case 1:
      return lang.improvement;
    case 3:
      return lang.vandalism;
    case 4:
      return lang.other;
    default:
      return lang.other;
  }
};
